import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-dialog-submit-discount',
  templateUrl: './dialog-submit-discount.component.html',
  styleUrls: ['./dialog-submit-discount.component.scss']
})
export class DialogSubmitDiscountComponent implements OnInit {

  dataValues: any;
  displayedColumns: string[];

  constructor(public dialogData: MatDialogRef<DialogSubmitDiscountComponent>, @Inject(MAT_DIALOG_DATA) data) {
    this.displayedColumns = [ 'confirmed', 'numAnno', 'region', 'localCustomer'];
    this.dataValues = data.result;
  }

  ngOnInit() {
  }

  save() {
    this.dialogData.close();
  }

  close() {
    this.dialogData.close();
  }

}
